import React from "react";
import { useTranslation } from "react-i18next";
import { FormGroup, Input, FormFeedback } from 'reactstrap';

interface ModulePeriodDateMonthPickerProps {
    month: number | undefined
    date: number | undefined
    monthName: string
    dateName: string
    disabled: boolean
    onChangePeriod: (name: string, value: number) => void
    validation: string[]
}

const months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

const ModulePeriodDateMonthPicker: React.FC<ModulePeriodDateMonthPickerProps> = (props) => {

    const { t } = useTranslation(['configuration','common']);

    const month = props.month;
    const dates = [{ value: 1 }, { value: 2 }, { value: 3 }, { value: 4 }, { value: 5 }, { value: 6 }, { value: 7 }, { value: 8 }, { value: 9 }, { value: 10 }, { value: 11 }, { value: 12 }, { value: 13 }, { value: 14 }, { value: 15 }, { value: 16 }, { value: 17 }, { value: 18 }, { value: 19 }, { value: 20 }, { value: 21 }, { value: 22 }, { value: 23 }, { value: 24 }, { value: 25 }, { value: 26 }, { value: 27 }, { value: 28 }, { value: 29, disabled: month === 2 }, { value: 30, disabled: month === 2 }, { value: 31, disabled: month === 2 || month === 4 || month === 6 || month === 9 || month === 11 }]

    return (
        <FormGroup>
            <FormGroup style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div style={{ width: '48%' }}>
                    <Input
                        type="select"
                        value={props.month || ''}
                        disabled={props.disabled}
                        onChange={e => props.onChangePeriod(props.monthName, parseInt(e.target.value))}
                        invalid={props.validation.indexOf(props.monthName) !== -1}
                    >
                        <option value="" disabled>{t('dateMonthPicker.pickMonth')}</option>
                        {months.map(m => <option key={m} value={m}>{t(`months.${m}`, { ns: 'common' })}</option>)}
                    </Input>
                    <FormFeedback>{t('dateMonthPicker.dateRequired')}</FormFeedback>
                </div>
                <div style={{ width: '48%' }}>
                    <Input
                        type="select"
                        value={props.date || ''}
                        disabled={props.disabled}
                        onChange={e => props.onChangePeriod(props.dateName, parseInt(e.target.value))}
                        invalid={props.validation.indexOf(props.dateName) !== -1}
                    >
                        <option value="" disabled>{t('dateMonthPicker.pickDate')}</option>
                        {dates.map(m => <option key={m.value} value={m.value} disabled={m.disabled}>{m.value}</option>)}
                    </Input>
                    <FormFeedback>{t('dateMonthPicker.dateRequired')}</FormFeedback>
                </div>
            </FormGroup>
        </FormGroup>
    )
}

export default ModulePeriodDateMonthPicker;
